<template>
    <v-btn icon @click="dialog = true" color="secondary">
        <v-icon>mdi-trophy</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" max-width="600px">
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title>{{ t('Ranking') }}</v-toolbar-title>
                <v-spacer />
                <v-btn icon @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-tabs v-model="tab" bg-color="secondary">
                <v-tab value="global">
                    {{ t('Global') }}
                </v-tab>
                <v-tab v-for="year in years" :key="year" :value="year">
                    {{ year }}
                </v-tab>
            </v-tabs>
            <v-card-text>
                <v-window v-model="tab">
                    <v-window-item value="global">
                        <v-list>
                            <v-list-item v-for="(user, index) in ranking" :key="user.usuario_id">
                                <template v-slot:prepend>
                                    <v-chip variant="text" class="mr-4">
                                        <template v-if="index < 10">
                                            <v-icon :color="medalColors[index]">
                                                {{ medalIcons[index] }}
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            <span class="font-weight-medium">{{ index + 1 }}</span>
                                        </template>
                                    </v-chip>
                                </template>
                                <v-list-item-title>{{ user.nickname }}</v-list-item-title>
                                <template v-slot:append>
                                    {{ user.puntos }}
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-window-item>
                    <v-window-item v-for="year in years" :key="year" :value="year">
                        <v-list two-line>
                            <v-list-item v-for="(user, i) in rankingsByYear[year]" :key="user.usuario_id">
                                <template v-slot:prepend>
                                    <v-chip variant="text" class="mr-4">
                                        <template v-if="i < 10">
                                            <v-icon :color="medalColors[i]">
                                                {{ medalIcons[i] }}
                                            </v-icon>
                                        </template>
                                        <template v-else>
                                            {{ i + 1 }}
                                        </template>
                                    </v-chip>
                                </template>
                                <v-list-item-title>{{ user.nickname }}</v-list-item-title>
                                <template v-slot:append>
                                    {{ user.puntos }}
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-window-item>
                </v-window>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'

// Internacionalización
const { t } = useI18n()

// Desestructuramos la prop ranking para evitar 'props' sin usar
const { ranking } = defineProps({
    ranking: {
        type: Array,
        default: () => []
    }
})

const dialog = ref(false)
const tab = ref('global')
const years = computed(() =>
    Array.from(new Set(ranking.map(u => u.year)))
        .sort((a, b) => b - a)
)
// Rankings por año: un objeto { [year]: [usuarios...] }
const rankingsByYear = computed(() => {
    const map = {}
    years.value.forEach(year => {
        map[year] = ranking
            .filter(u => u.year === year)
            .sort((a, b) => b.puntos - a.puntos)
    })
    return map
})
// Iconos y colores para oro, plata y bronce
const medalIcons = [
    'mdi-medal',  // oro
    'mdi-medal',  // plata
    'mdi-medal',   // bronce
    'mdi-numeric-4-circle-outline',
    'mdi-numeric-5-circle-outline',
    'mdi-numeric-6-circle-outline',
    'mdi-numeric-7-circle-outline',
    'mdi-numeric-8-circle-outline',
    'mdi-numeric-9-circle-outline',
    'mdi-numeric-10-circle-outline',
]

const medalColors = [
    'amber darken-2',   // oro
    'grey lighten-1',   // plata
    'orange darken-2',   // bronce
    'black', 
    'black',
    'black',
    'black',
    'black',
    'black',
    'black',
]
</script>